import ggAxiosConfig from 'ggApp/modules/axiosConfig';
import {
    PRODUCT_WIDGET,
    PRODUCT_WIDGET_FAILURE,
    PRODUCT_WIDGET_SUCCESS,
} from 'ggApp/modules/productWidget/constants';
import axios from 'ggApp/utils/requests';
import { authenticatedBasedOnCookies } from 'ggApp/modules/auth/utils';
import CookiesManager, { injectCookiesToConfig } from 'ggApp/utils/CookiesManager';

export function getProductWidgets(params, location, req) {
    const cookiesManager = new CookiesManager(req);
    return (dispatch, getState) => {
        const state = getState();
        const config = ggAxiosConfig.selectors.config(state);
        injectCookiesToConfig(cookiesManager, config);
        const loggedIn = authenticatedBasedOnCookies(cookiesManager);
        const endpointSuffix = loggedIn ? 'personalized' : 'general';
        const apiEndpoint = `/product_widgets/${endpointSuffix}?minimal_images=true`;
        dispatch({
            type: PRODUCT_WIDGET,
        });
        return axios
            .get(apiEndpoint, config)
            .then(({ data }) =>
                data.widgetList.reduce((finalWidgets, widgetData) => {
                    return finalWidgets.concat(widgetData);
                }, []),
            )
            .then((data) => {
                dispatch({
                    type: PRODUCT_WIDGET_SUCCESS,
                    data,
                });
            })
            .catch((error) =>
                dispatch({
                    type: PRODUCT_WIDGET_FAILURE,
                    error,
                }),
            );
    };
}
